import React from "react";
import {
  Box,
  Container,
  Image,
  Text,
  VStack,
  Grid,
  GridItem,
  useColorModeValue,
  Circle,
  Card,
  CardBody,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import SeeMoreButton from "../Common/SeeMoreButton";
import { serviceLinks } from "../../constants/navigationData";

const ServicesSection = () => {
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("rgba(0, 11, 140, 1)");
  const navigate = useNavigate();

  // Get first 6 services for homepage display
  const homeServices = serviceLinks.slice(0, 6);

  return (
    <Box py={10}>
      <Container maxW="7xl">
        {/* Header Section */}
        <VStack spacing={6} mb={16} textAlign="center">
          <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold">
            <Text as="span" color="#000B8C">
              Our
            </Text>{" "}
            Services
          </Text>
          <Text
            fontSize={{ base: "sm", md: "md" }}
            color={textColor}
            maxW="5xl"
            lineHeight="1.6"
          >
            Discover our comprehensive range of technology solutions designed to meet your business needs.
          </Text>
        </VStack>

        {/* Services Grid */}
        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          }}
          gap={8}
          mb={16}
        >
          {homeServices.map((service, index) => (
            <GridItem key={service.id}>
              <Card
                borderRadius="2xl"
                border="1px solid"
                borderColor="gray.100"
                transition="all 0.3s ease"
                _hover={{
                  bg: "blue.50", // Very light blue background on hover
                  "& .service-title": {
                    color: "blue.700" // Darker blue text for contrast on light blue background
                  },
                  "& .service-description": {
                    color: "#000B8C" // Medium blue text for description
                  },
                  "& .service-icon": {
                    color: "#000B8C" // Blue icon color
                  },
                  "& .service-arrow": {
                    bg: "blue.100",
                    color: "#000B8C"
                  }
                }}
                cursor="pointer"
                h="full"
                onClick={() => navigate(service.href)}
              >
                <CardBody p={8}>
                  <VStack align="flex-start" spacing={6} h="full">
                    {/* Icon */}
                    <Box p={0} borderRadius="xl" transition="all 0.3s ease">
                      <Image
                        src={service.image}
                        alt={service.title}
                        w={8}
                        h={8}
                        className="service-icon"
                        transition="color 0.3s ease"
                      />
                    </Box>

                    {/* Content */}
                    <VStack align="flex-start" spacing={4} flex="1">
                      <Text
                        fontSize={{ base: "xl", md: "2xl" }}
                        color={headingColor}
                        className="service-title"
                        lineHeight="1.3"
                        transition="color 0.3s ease"
                      >
                        {service.title}
                      </Text>
                      <Text
                        color={textColor}
                        className="service-description"
                        fontSize="md"
                        lineHeight="1.6"
                        flex="1"
                        noOfLines={3}
                        transition="color 0.3s ease"
                      >
                        {service.description}
                      </Text>
                    </VStack>

                    {/* Arrow Button */}
                    <Flex justify="flex-end" w="full" mt="auto">
                      <Circle
                        size="48px"
                        bg="gray.100"
                        color="gray.600"
                        className="service-arrow"
                        transition="all 0.3s ease"
                        cursor="pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(service.href);
                        }}
                      >
                        <Image
                          src="/png/corner-arrow.png"
                          w={5}
                          h={5}
                          objectFit="cover"
                        />
                      </Circle>
                    </Flex>
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </Grid>

        {/* See More Button */}
        <SeeMoreButton
          onClick={() => navigate("/our-services")}
          text="Explore All"
          colors={{
            textColor: "black",
            textBorder: "1px solid black",
            textHover: "#000B8C",
            iconBg: "rgba(0, 11, 140, 1)",
            iconHover: "#1a3d17",
          }}
        />
        {/* <Flex justify="center">
          <Button
            size="lg"
            bg="rgba(243, 244, 254, 1)"
            color="gray.700"
            border="1px solid"
            borderColor="rgba(173, 177, 230, 1)"
            px={8}
            py={6}
            borderRadius="full"
            _hover={{
              bg: "#000B8C",
              color: "white",
              borderColor: "#000B8C",
              transform: "translateY(-2px)",
              shadow: "lg",
            }}
            _active={{
              transform: "translateY(0)",
            }}
            transition="all 0.3s ease"
            rightIcon={
              <Circle
                size="32px"
                bg="#000B8C"
                color="white"
                ml={4}
                transition="all 0.3s ease"
                _groupHover={{
                  bg: "white",
                  color: "#000B8C",
                }}
              >
                <Icon as={ArrowRight} w={4} h={4} />
              </Circle>
            }
            onClick={() => navigate("/our-services")}
          >
            See more Service
          </Button> */}
        {/* </Flex> */}
      </Container>
    </Box>
  );
};

export default ServicesSection;
